(function () {
  'use strict';

  // ── Element refs ────────────────────────────────────────────────────────────
  var valueInput         = document.getElementById('gc-value');
  var incrementBtn       = document.getElementById('gc-value-increment');
  var decrementBtn       = document.getElementById('gc-value-decrement');
  var sendToSelect       = document.getElementById('gc-send-to');

  var summaryValue       = document.getElementById('summary-value');
  var summaryTotal       = document.getElementById('summary-total');
  var summarySend        = document.getElementById('summary-send');

  var fieldsSomeoneElse  = document.getElementById('gc-fields-someone-else');
  var fieldConfirmYour   = document.getElementById('gc-field-confirm-your-email');

  var recipientEmail     = document.getElementById('gc-recipient-email');
  var recipientEmailConf = document.getElementById('gc-recipient-email-confirm');
  var senderName         = document.getElementById('gc-sender-name');
  var senderEmail        = document.getElementById('gc-sender-email');
  var senderEmailConf    = document.getElementById('gc-sender-email-confirm');
  var messageField       = document.getElementById('gc-message');

  // Send Timing Options
  var timingRadios       = document.querySelectorAll('input[name="gc-send-timing"]');
  var dateTimePicker     = document.getElementById('gc-date-time-picker');
  var sendDateInput      = document.getElementById('gc-send-date');
  var sendTimeInput      = document.getElementById('gc-send-time');
  var timestampInput     = document.getElementById('gc-added-to-cart-timestamp');

  var form               = document.querySelector('.gc-form');
  if (!form) {
    console.error('Gift card form not found.');
    return;
  }
  var gcLayout           = document.querySelector('.gc-layout');

  // Preview panel elements
  var previewPanel           = document.getElementById('gc-preview-panel');
  var previewBtn             = document.getElementById('gc-preview-btn');
  var cancelPreviewBtn       = document.getElementById('gc-cancel-preview-btn');
  var addToCartBtn           = document.getElementById('gc-add-to-cart-btn');

  var previewCardAmount      = document.getElementById('preview-card-amount');
  var previewMessageWrap     = document.getElementById('preview-message-wrap');
  var previewSenderNameLabel = document.getElementById('preview-sender-name-label');
  var previewMessageText     = document.getElementById('preview-message-text');

  // ── Helpers ─────────────────────────────────────────────────────────────────
  function formatAmount(n) {
    return 'R ' + n.toLocaleString('en-ZA');
  }

  function getCurrentValue() {
    var v = parseInt(valueInput.value, 10);
    return isNaN(v) || v < 1 ? 0 : v;
  }

  // ── Value stepper (+/- R100) ─────────────────────────────────────────────────
  var valueStep = parseInt(valueInput.step, 10) || 100;
  var valueMin  = parseInt(valueInput.min, 10) || 0;
  var valueMax  = parseInt(valueInput.max, 10) || 10000;

  function stepValue(delta) {
    var current = parseInt(valueInput.value, 10);
    if (isNaN(current)) current = valueMin;
    var next = Math.min(valueMax, Math.max(valueMin, current + delta));
    valueInput.value = next;
    valueInput.dispatchEvent(new Event('input', { bubbles: true }));
    valueInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function isValidEmail(val) {
    return emailRe.test(val.trim());
  }

  // ── Error display ────────────────────────────────────────────────────────────
  function setError(el, message) {
    clearError(el);
    el.classList.add('gc-input--error');
    var err = document.createElement('p');
    err.className = 'gc-field-error';
    err.textContent = message;
    el.parentNode.insertAdjacentElement('afterend', err);
  }

  function clearError(el) {
    el.classList.remove('gc-input--error');
    var next = el.parentNode.nextElementSibling;
    if (next && next.classList.contains('gc-field-error')) {
      next.remove();
    }
  }

  // ── Clear All Errors ─────────────────────────────────────────────────────────
  function clearAllErrors() {
    form.querySelectorAll('.gc-input--error').forEach(function (el) {
      el.classList.remove('gc-input--error');
    });
    form.querySelectorAll('.gc-field-error').forEach(function (el) {
      el.remove();
    });
  }

  // ── Send summary label ───────────────────────────────────────────────────────
  function updateSendSummaryLabel() {
    if (!summarySend) return;
    var date = sendDateInput ? sendDateInput.value : '';
    var time = sendTimeInput ? sendTimeInput.value : '';
    if (date && time) {
      var dt = new Date(date + 'T' + time);
      summarySend.textContent = dt.toLocaleString('en-ZA', {
        day: '2-digit', month: 'short', year: 'numeric',
        hour: '2-digit', minute: '2-digit'
      });
    } else if (date) {
      var d = new Date(date);
      summarySend.textContent = d.toLocaleDateString('en-ZA', {
        day: '2-digit', month: 'short', year: 'numeric'
      });
    } else {
      summarySend.textContent = 'Later';
    }
  }

  // ── Dynamic Form Field Toggles ───────────────────────────────────────────────
  function applySendTimingState() {
    var selectedTiming = 'now';
    timingRadios.forEach(function (radio) {
      if (radio.checked) {
        selectedTiming = radio.value;
      }
    });

    if (selectedTiming === 'later') {
      if (dateTimePicker) dateTimePicker.style.display = 'block';
      // Default the date and time inputs to the current local date/time,
      // but only if they haven't already been set by the user.
      if (sendDateInput && !sendDateInput.value) {
        var now = new Date();
        var pad = function (n) { return String(n).padStart(2, '0'); };
        sendDateInput.value = now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate());
      }
      if (sendTimeInput && !sendTimeInput.value) {
        var nowT = new Date();
        var padT = function (n) { return String(n).padStart(2, '0'); };
        sendTimeInput.value = padT(nowT.getHours()) + ':' + padT(nowT.getMinutes());
      }
      updateSendSummaryLabel();
    } else {
      if (dateTimePicker) dateTimePicker.style.display = 'none';
      if (summarySend) summarySend.textContent = 'Immediately';
      if (sendDateInput) { sendDateInput.value = ''; clearError(sendDateInput); }
      if (sendTimeInput) { sendTimeInput.value = ''; clearError(sendTimeInput); }
    }
  }

  // ── Validation ───────────────────────────────────────────────────────────────
  function validate() {
    clearAllErrors();
    var valid = true;
    var firstInvalid = null;

    function fail(el, msg) {
      setError(el, msg);
      if (!firstInvalid) firstInvalid = el;
      valid = false;
    }

    if (getCurrentValue() < 100) {
      fail(valueInput, 'Please enter a value of at least R100.');
    }
    
    if (getCurrentValue() > valueMax) {
      fail(valueInput, 'Please enter a value of ' + formatAmount(valueMax) + ' or less.');
    }

    if (sendToSelect.value === 'someone_else') {
      if (!isValidEmail(recipientEmail.value)) {
        fail(recipientEmail, 'Please enter a valid recipient email address.');
      } else if (recipientEmail.value.trim() !== recipientEmailConf.value.trim()) {
        fail(recipientEmailConf, 'Recipient email addresses do not match.');
      }

      if (senderName.value.trim().length < 2) {
        fail(senderName, 'Please enter your name.');
      }

      if (!isValidEmail(senderEmail.value)) {
        fail(senderEmail, 'Please enter a valid email address.');
      }
    } else {
      if (!isValidEmail(senderEmail.value)) {
        fail(senderEmail, 'Please enter a valid email address.');
      } else if (senderEmail.value.trim() !== senderEmailConf.value.trim()) {
        fail(senderEmailConf, 'Email addresses do not match.');
      }
    }

    // Process Date and Time conditional requirement rules
    var timingValue = 'now';
    timingRadios.forEach(function (radio) {
      if (radio.checked) timingValue = radio.value;
    });

    if (timingValue === 'later') {
      if (!sendDateInput || !sendDateInput.value) {
        fail(sendDateInput || dateTimePicker, 'Please choose a future delivery date.');
      }
      if (!sendTimeInput || !sendTimeInput.value) {
        fail(sendTimeInput || dateTimePicker, 'Please choose a specific delivery time.');
      }
    }

    if (firstInvalid) {
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstInvalid.focus();
    }

    return valid;
  }

  // ── Clear individual error as user corrections occur ──────────────────────────
  var clearInputTargets = [valueInput, recipientEmail, recipientEmailConf, senderName, senderEmail, senderEmailConf];
  if (sendDateInput) clearInputTargets.push(sendDateInput);
  if (sendTimeInput) clearInputTargets.push(sendTimeInput);

  clearInputTargets.forEach(function (el) {
    if (el) {
      el.addEventListener('input', function () { clearError(el); });
    }
  });

  // ── Summary sync ─────────────────────────────────────────────────────────────
  function updateSummary() {
    var val = getCurrentValue();
    summaryValue.textContent = formatAmount(val);
    summaryTotal.textContent = formatAmount(val);
  }

  // ── Send-to toggle ───────────────────────────────────────────────────────────
  function applySendToState() {
    var isYourself = sendToSelect.value === 'yourself';
    fieldsSomeoneElse.style.display = isYourself ? 'none' : '';
    fieldConfirmYour.style.display  = isYourself ? ''     : 'none';

    clearAllErrors();

    if (isYourself) {
      fieldsSomeoneElse.querySelectorAll('input, textarea').forEach(function (el) {
        el.value = '';
      });
    } else {
      senderEmailConf.value = '';
    }
  }

  // ── Populate & show preview panel ────────────────────────────────────────────
  function showPreview() {
    var val = getCurrentValue();
    var formattedVal = formatAmount(val);
    var isForSomeoneElse = sendToSelect.value === 'someone_else';

    if (previewCardAmount) {
      previewCardAmount.textContent = formattedVal;
    }

    var msg = messageField ? messageField.value.trim() : '';
    if (isForSomeoneElse && msg) {
      if (previewSenderNameLabel) {
        previewSenderNameLabel.textContent = (senderName.value.trim() || 'your sender').toUpperCase();
      }
      if (previewMessageText) {
        previewMessageText.textContent = '"' + msg + '"';
      }
      if (previewMessageWrap) {
        previewMessageWrap.style.display = 'table';
      }
    } else {
      if (previewMessageWrap) {
        previewMessageWrap.style.display = 'none';
      }
    }

    gcLayout.style.display = 'none';
    previewPanel.style.display = '';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // ── Hide preview, return to form ─────────────────────────────────────────────
  function hidePreview() {
    previewPanel.style.display = 'none';
    gcLayout.style.display = '';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function previewSubmitHandler(e) {
    e.preventDefault();
    if (validate()) {
      showPreview();
    }
  }

  // ── Listeners ────────────────────────────────────────────────────────────────
  if (previewBtn) {
    previewBtn.addEventListener('click', function () {
      if (validate()) {
        showPreview();
      }
    });
  }

  if (cancelPreviewBtn) {
    cancelPreviewBtn.addEventListener('click', hidePreview);
  }

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function (e) {
      e.preventDefault();

      if (!validate()) {
        hidePreview();
        return;
      }
      if (timestampInput) {
        var sendTimingValue = '';
        timingRadios.forEach(function (radio) {
          if (radio.checked) sendTimingValue = radio.value;
        });

        var isoString;
        if (sendTimingValue === 'later' && sendDateInput && sendTimeInput) {
          var dateValueArr = sendDateInput.value.split('-');
          var year  = parseInt(dateValueArr[0], 10);
          var month = parseInt(dateValueArr[1], 10) - 1;
          var day   = parseInt(dateValueArr[2], 10);
          var timeValueArr = sendTimeInput.value.split(':');
          var hours   = parseInt(timeValueArr[0], 10);
          var minutes = parseInt(timeValueArr[1], 10);
          isoString = new Date(year, month, day, hours, minutes).toISOString();
        } else {
          isoString = new Date().toISOString();
        }

        timestampInput.setAttribute('value', isoString);
        timestampInput.value = isoString;
      }
      form.removeEventListener('submit', previewSubmitHandler);
      setTimeout(function () {
        HTMLFormElement.prototype.submit.call(form);
      }, 50);
    });
  }

  form.addEventListener('submit', previewSubmitHandler);
  valueInput.addEventListener('input', updateSummary);
  valueInput.addEventListener('change', updateSummary);
  sendToSelect.addEventListener('change', applySendToState);

  if (incrementBtn) incrementBtn.addEventListener('click', function () { stepValue(valueStep); });
  if (decrementBtn) decrementBtn.addEventListener('click', function () { stepValue(-valueStep); });

  timingRadios.forEach(function (radio) {
    radio.addEventListener('change', applySendTimingState);
  });

  // ── Live update send summary as user picks date/time ─────────────────────────
  if (sendDateInput) sendDateInput.addEventListener('change', updateSendSummaryLabel);
  if (sendTimeInput) sendTimeInput.addEventListener('change', updateSendSummaryLabel);

  // ── Init ─────────────────────────────────────────────────────────────────────
  updateSummary();
  applySendToState();
  applySendTimingState();
})();